






































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { RequestMessage as MSG, TipoUsuarioEnum } from '@/types/_'
// eslint-disable-next-line
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'

@Component

export default class ComponentModalSolicitacaoCancelamentoBase extends Vue {
  @Prop({ required: true }) tipoUsuario: TipoUsuarioEnum
  @Prop({ required: false, default: false }) disabled: boolean
  @Prop({ required: false, default: '' }) subtitle: boolean

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get getHabilitarObservacaoDoCancelamento() {
    return this.getSolicitacaoCancelamentoStore.habilitarObservacaoDoCancelamento
  }

  get getMotivo() {
    return this.getSolicitacaoCancelamentoStore.motivo
  }

  set getMotivo(value: string) {
    this.getSolicitacaoCancelamentoStore.setMotivo(value)
  }

  get getObservacaoDoCancelamento() {
    return this.getSolicitacaoCancelamentoStore.observacaoDoCancelamento
  }

  set getObservacaoDoCancelamento(message: string) {
    this.getSolicitacaoCancelamentoStore.setObservacaoCancelamento(message)
  }

  get getMotivoMessage() {
    return this.getSolicitacaoCancelamentoStore.motivoMessage
  }

  set getMotivoMessage(value: string) {
    this.getSolicitacaoCancelamentoStore.setMotivoMessage(value)
  }

  get getMotivos() {
    return this.getSolicitacaoCancelamentoStore.motivosCancelamento
  }

  get getBackofficeArea() {
    const routeName = this.$route.name || ''
    return ['BackofficeAgendamento', 'agendamentoMedico'].includes(routeName)
  }
}
